import {useEffect, useState} from "react";


export const fetchAndStoreCompanyLogoUrl = async (cid) => {
    if (!cid) {
        cid = localStorage.getItem('cid') || 'finiat';
    }
    try {
        const response = await fetch(`https://storage.googleapis.com/finiat-web-static-resources/company-brands/id-lookup/${cid}`);
        if (!response.ok) {
            throw new Error('Failed to fetch company brand');
        }
        const data = await response.json();
        const logoUrl = data.logo_url;
        if (logoUrl) {
            // Store the logo URL in localStorage
            localStorage.setItem('companyLogoUrl', logoUrl);
        }
    } catch (error) {
        console.error('Error fetching company logo URL:', error);
    }
};


const COMPANY_LOGO_PATH = 'https://storage.googleapis.com/finiat-web-static-resources/company-brands/id-lookup';


export const formatCompanyLogoUrl = (cid)=>{
    if (!cid){
        cid = localStorage.getItem('cid') || 'finiat'
    }
    if (cid==='community'){
        cid = 'finiat'
    }
    return `${COMPANY_LOGO_PATH}/${cid}.png`
}


// Assuming placeholder URL or null
const PLACEHOLDER_LOGO_URL = null;

export const CompanyBrand = ({ cid }) => {
    const [logoUrl, setLogoUrl] = useState(() => localStorage.getItem('companyLogoUrl') || PLACEHOLDER_LOGO_URL);

    useEffect(() => {
        // Fetch and store company logo URL if not already in localStorage
        const fetchLogo = async () => {
            if (!localStorage.getItem('companyLogoUrl') || cid !== localStorage.getItem('cid')) {
                await fetchAndStoreCompanyLogoUrl(cid);
                setLogoUrl(localStorage.getItem('companyLogoUrl') || PLACEHOLDER_LOGO_URL);
            }
        };
        fetchLogo();
    }, [cid]);

    return logoUrl; // This component now returns the logo URL
};